import { API_URL } from './../../../actions/utilAction';
import { actionCreator,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    extractDataFromObject,
    jsonApiHeader,
    showSuccessMessage,
} from './../../../actions/utilAction';

export { jsonApiHeader,
    actionCreator,
    checkHttpStatus,
    createSearchUrl,
    create_post_data,
    showSuccessMessage,
    extractDataFromObject,
   API_URL,
};

export const GET_ORGANIZATIONAUTHORIZATION = `${API_URL}/AdminDashboard/GetOrganizationAuthorization`;
export const GET_ORGANIZATIONENCOUNTER = `${API_URL}/AdminDashboard/GetOrganizationEncounter`;
export const GET_DASHBOARDDATA = `${API_URL}/AdminDashboard/GetAdminDashboardData`;
export const GET_STAFFENCOUNTER = `${API_URL}/AdminDashboard/GetStaffEncounters`;
export const GET_CHECKUSERPASSWORDSTATUS = `${API_URL}/User/CheckUserPasswordStatus`;
export const GET_ORGANIZATIONSTAFFDOCUMENTS = `${API_URL}/AdminDashboard/GetOrganizationStaffDocuments`;
export const GET_ORGANIZATIONCLIENTDOCUMENTS = `${API_URL}/AdminDashboard/GetOrganizationClientDocuments`;
export const GET_STAFFDOCUMENTS = `${API_URL}/AdminDashboard/GetStaffDocuments`;
export const GET_CLIENTDOCUMENTS = `${API_URL}/AdminDashboard/GetClientDocuments`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const GET_PATIENT = `${API_URL}/api/PatientAppointments/GetStaffAndPatientByLocation`;
export const GET_ORGANIZATIONBILLABLEHOURSGRAPH = `${API_URL}/AdminDashboard/GetBillableHoursGraph`;
export const GET_ORGANIZATIONOARESPONSES = `${API_URL}/AdminDashboard/GetOAResponses`;
export const GET_ORGANIZATIONFINANCIALKPIGRAPH = `${API_URL}/AdminDashboard/GetOrganizationFinancialKPIGraph`;
export const GET_ORGANIZATIONPAYERRESPONSES = `${API_URL}/AdminDashboard/GetPayerResponses`;
export const GET_ExportCSVOrExcelOAREJECTIONS = `${API_URL}/AdminDashboard/GetOAResponsesExportAsCSVAndXLS`;
export const GET_PayerResponsesExportAsCSVAndXLS = `${API_URL}/AdminDashboard/GetPayerResponsesExportAsCSVAndXLS`;
export const GET_ExportCSVOrExcelStaffDocuments =  `${API_URL}/AdminDashboard/GetOrganizationStaffDocumentsExportAsCSVAndXLS`;
export const GET_ExportCSVOrExcelClientDocuments = `${API_URL}/AdminDashboard/GetOrganizationClientDocumentsExportAsCSVAndXLS`;
export const GET_ExportCSVOrExcelAppointmentDocuments = `${API_URL}/AdminDashboard/GetOrganizationEncounterExportAsCSVAndXLS`;
export const GET_ExportCSVOrExcelStaffNonAdminDocuments = `${API_URL}/AdminDashboard/GetStaffDocumentsExportAsCSVAndXLS`;
export const GET_ExportCSVOrExcelClientNonAdminDocuments = `${API_URL}/AdminDashboard/GetClientDocumentsExportAsCSVAndXLS`;
export const GET_ExportCSVOrExcelAuthorizationDocuments = `${API_URL}/AdminDashboard/GetOrganizationAuthorizationExportAsCSVAndXLS`;

export const AgencyDashboardActionTypes = {
    get_DashboardData: createRequestActionTypes('GET_DASHBOARDDATA'),
    get_OrganizationAuthorization: createRequestActionTypes('GET_ORGANIZATIONAUTHORIZATION'),
    get_OrganizationEncounter: createRequestActionTypes('GET_ORGANIZATIONENCOUNTER'),
    get_StaffEncounter: createRequestActionTypes('GET_STAFFENCOUNTER'),
    get_CheckUserPasswordStatus: createRequestActionTypes('GET_CHECKUSERPASSWORDSTATUS'),
    get_OrganizationStaffDocuments: createRequestActionTypes('GET_ORGANIZATIONSTAFFDOCUMENTS'),    
    get_OrganizationClientDocuments: createRequestActionTypes('GET_ORGANIZATIONCLIENTDOCUMENTS'),    
    get_StaffDocuments: createRequestActionTypes('GET_STAFFDOCUMENTS'),
    get_ClientDocuments: createRequestActionTypes('GET_CLIENTDOCUMENTS'),
    get_masterdata: createRequestActionTypes('GET_MASTERSDATA'),
    get_patient: createRequestActionTypes('GET_PATIENT'),
    get_OrganizationBillableHoursGraph: createRequestActionTypes('GET_ORGANIZATIONBILLABLEHOURSGRAPH'),  
    get_OrganizationOAResponses: createRequestActionTypes('GET_ORGANIZATIONOARESPONSES'),  
    get_OrganizationFinancialKPIGraph: createRequestActionTypes('GET_ORGANIZATIONFINANCIALKPIGRAPH'),  
    get_OrganizationPayerResponses: createRequestActionTypes('GET_ORGANIZATIONPAYERRESPONSES'),  
    get_ExportCSVOrExcelOARejections: createRequestActionTypes('GET_ExportCSVOrExcelOAREJECTIONS'),
    get_PayerResponsesExportAsCSVAndXLS: createRequestActionTypes('GET_PayerResponsesExportAsCSVAndXLS'),
    get_ExportCSVOrExcelStaffDocuments: createRequestActionTypes('GET_ExportCSVOrExcelStaffDocuments'),
    get_ExportCSVOrExcelClientDocuments: createRequestActionTypes('GET_ExportCSVOrExcelClientDocuments'),
    get_ExportCSVOrExcelAppointmentDocuments: createRequestActionTypes('GET_ExportCSVOrExcelAppointmentDocuments'),
    get_ExportCSVOrExcelStaffNonAdminDocuments: createRequestActionTypes('GET_ExportCSVOrExcelStaffNonAdminDocuments'),
    get_ExportCSVOrExcelClientNonAdminDocuments: createRequestActionTypes('GET_ExportCSVOrExcelClientNonAdminDocuments'),
    get_ExportCSVOrExcelAuthorizationDocuments: createRequestActionTypes('GET_ExportCSVOrExcelAuthorizationDocuments')
};




// WEBPACK FOOTER //
// ./src/modules/Dashboards/constants/ApiConstants.js